import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  create: async (data) => {
    const body = new FormData();
    Array.from(data.files).forEach((element) => {
      body.append('files', element);
    });
    body.append('type', data.type);

    return request(`${API_URL}/files`, 'post', body);
  },
  delete: async (id) => {
    return request(`${API_URL}/files/${id}`, 'delete', {}, {});
  },
};
